<template>
  <div style="margin-top: 0.6rem">
    <div class="bottom" >
      <div style="margin-left: 15%;padding-top: 1%">
        <div style="font-size: 1rem;margin-bottom: 0.7rem;">内江投资控股集团有限公司</div>
        <div style="margin-bottom: 0.7rem;font-size: 0.7rem">地址：内江市东兴区太白路69号</div>
        <div style="margin-bottom: 0.7rem;font-size: 0.7rem">电话：0832-2220609</div>
        <div style="margin-bottom: 0.7rem;font-size: 0.7rem">邮箱：826848830@qq.com</div>
        <div style="margin-bottom: 0.7rem;font-size: 0.7rem">版权所有：内江投资控股集团有限公司</div>
      </div>
      <div style="margin-left: 2.4rem;">
        <div style="height: 1.2rem"></div>
        <div style="margin-bottom: 0.7rem;font-size: 0.7rem;text-align: center">关联公众号：内江投资控股集团有限公司</div>
        <div style="text-align: center" >
          <img src="@/assets/image/wechat.jpg" style="width: 5rem">
        </div>
        <div style="display: flex;font-size: 0.7rem" >
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white">蜀ICP备2021002812号-2</a>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white;margin-left: 0.5rem">蜀ICP备2021002812号</a>
          <img :src="require('@/assets/jinghui.png')" style="margin-left: 0.5rem;height: 1rem">
          <a href="https://beian.mps.gov.cn/#/query/websearch?code=51101102000203" rel="noreferrer" target="_blank" style="color: white">川公网安备51101102000203</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showComponent'],
  methods: {}
}
</script>

<style scoped>
.bottom {
  display: flex;
  /*margin-top: 30px;*/
  background-color: #234C9C;
  color: white;
  font-size: 14px;
  height: 160px;
}
</style>
